import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className="about-page">

      {/* Hero Section */}
      <section className="about-hero">
        <h1>About Us</h1>
        <h2>Welcome To Mehar Tour And Travels</h2>
        <p>
          Mehar Tour And Travels is your trusted travel companion for discovering
          the breathtaking beauty of Himachal Pradesh and North India. With years
          of expertise in crafting unforgettable journeys, we specialize in
          delivering customized travel packages for every kind of traveler —
          adventure lovers, honeymoon couples, families, and spiritual seekers.
        </p>
      </section>

      {/* Main About Content */}
      <section className="about-content">
        <div className="about-box">
          <h3>Who We Are</h3>
          <p>
            Our mission is to provide a seamless and enriching travel experience
            that lets you truly immerse yourself in the charm of the Himalayas.
            Whether it's the snowy slopes of Manali, the colonial charm of Shimla,
            the spiritual serenity of Dharamshala, or exploring Chandigarh and
            nearby hill destinations — we bring you the best with comfort, quality,
            and reliability.
          </p>
        </div>

        <div className="about-box">
          <h3>What We Offer</h3>
          <ul>
            <li>✔ Customized Himachal Tour Packages</li>
            <li>✔ Shimla, Manali, Dharamshala, Dalhousie Trips</li>
            <li>✔ Chandigarh, Amritsar & North India Tours</li>
            <li>✔ Honeymoon, Adventure & Family Packages</li>
            <li>✔ Comfortable Hotels & Private Cab Facilities</li>
          </ul>
        </div>

        <div className="about-box">
          <h3>Why Choose Us?</h3>
          <ul>
            <li>✔ Expert Local Travel Knowledge</li>
            <li>✔ Affordable & All-Inclusive Packages</li>
            <li>✔ Professional Drivers & Assured Safety</li>
            <li>✔ 24×7 Customer Support</li>
            <li>✔ 100% Client Satisfaction</li>
          </ul>
        </div>
      </section>

    </div>
  );
}
